module.exports = __webpack_public_path__ + "static/images/styles/images/reserves/rewards/additional-briefing-elite-reward-50.f34ad74e.png";


//////////////////
// WEBPACK FOOTER
// ./styles/images/reserves/rewards/additional-briefing-elite-reward-50.png
// module id = 3767
// module chunks = 11